




























































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { CreateServiceFormValue } from '../form/CreateServiceForm.vue'


@Component
export default class ConfirmCreateServiceModal extends Vue {
    @Prop({required: true})
    value!: CreateServiceFormValue

    previewUrl: string | null = null


    mounted() {
        if (this.value.file) {
            this.previewUrl = window.URL.createObjectURL(this.value.file)
        }
    }

}
